// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8c9c098c","389":"5a204c89","455":"c6652c58","977":"83a26df1"}[chunkId] + ".chunk.js";
};